/* HANTINO Redesign 2026 — tema-JS
   Varukorgs-drawer (Cart AJAX API), FAQ-accordion, återförsäljarfilter,
   märkes-/variantväljare. Inga externa beroenden. */
(function () {
  'use strict';

  /* ---------- Hjälpare ---------- */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  /* Oversattningar renderas till window.HNT_I18N av snippets/hantino-i18n.liquid */
  function T(key, fallback) { return (window.HNT_I18N && window.HNT_I18N[key]) || fallback; }

  var drawerRoot = null;
  function getDrawer() {
    if (!drawerRoot) drawerRoot = qs('[data-hnt-drawer-root]');
    return drawerRoot;
  }
  function vatFactor() {
    var d = getDrawer();
    var f = d ? parseFloat(d.getAttribute('data-vat-factor')) : 1.25;
    return isNaN(f) ? 1.25 : f;
  }
  function money(cents) {
    return Math.round((cents * vatFactor()) / 100) + ' kr';
  }

  /* ---------- Varukorg ---------- */
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function renderCart(cart) {
    var root = getDrawer();
    if (!root) return;
    var linesEl = qs('[data-hnt-lines]', root);
    var lines = cart.items.map(function (item) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var qtyPrefix = item.quantity > 1 ? item.quantity + ' × ' : '';
      return '<div class="hnt-drawer__line" data-line-key="' + item.key + '">' +
        '<div class="hnt-drawer__line-img">' + (item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_300x$1$2') + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="hnt-drawer__line-info">' +
          '<span class="hnt-drawer__line-name">' + escapeHtml(item.product_title) + '</span>' +
          (variant ? '<span class="hnt-drawer__line-variant">' + escapeHtml(variant) + '</span>' : '') +
          '<span class="hnt-drawer__line-price">' + qtyPrefix + money(item.final_price) + '</span>' +
        '</div>' +
        '<button type="button" class="hnt-drawer__line-remove" data-hnt-remove="' + item.key + '" aria-label="' + T('cart_remove', 'Ta bort') + ' ' + escapeHtml(item.product_title) + '">⌫</button>' +
      '</div>';
    }).join('');
    if (!cart.items.length) {
      lines = '<div class="hnt-drawer__empty">' + escapeHtml(T('cart_empty', 'Varukorgen är tom.')) + '</div>';
    }
    linesEl.innerHTML = lines;
    var totalEl = qs('[data-hnt-total]', root);
    if (totalEl) totalEl.textContent = money(cart.total_price);
    var countEls = qsa('[data-hnt-cart-count]');
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.closest('[data-hnt-cart-toggle]') && el.closest('[data-hnt-cart-toggle]').classList.toggle('is-empty', cart.item_count === 0);
    });
    var checkout = qs('[data-hnt-checkout]', root);
    if (checkout) checkout.style.display = cart.items.length ? '' : 'none';

    /* Behöver du också? — visa max 2 produkter som inte redan ligger i korgen */
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var shown = 0;
    qsa('.hnt-upsell-card', root).forEach(function (card) {
      var pid = parseInt(card.getAttribute('data-product-id'), 10);
      var show = inCart.indexOf(pid) === -1 && shown < 2;
      card.classList.toggle('is-visible', show);
      if (show) shown++;
    });
    var upsellWrap = qs('[data-hnt-upsell]', root);
    if (upsellWrap) upsellWrap.style.display = shown ? '' : 'none';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function openDrawer(mode) {
    var root = getDrawer();
    if (!root) return;
    var heading = qs('[data-hnt-drawer-heading]', root);
    if (heading) {
      heading.innerHTML = (mode === 'added'
        ? escapeHtml(T('cart_heading_added', 'tillagd i varukorgen'))
        : escapeHtml(T('cart_heading', 'varukorgen'))) + '<span class="hnt-accent">.</span>';
    }
    root.classList.add('is-open');
    document.body.classList.add('hnt-drawer-open');
  }
  function closeDrawer() {
    var root = getDrawer();
    if (!root) return;
    root.classList.remove('is-open');
    document.body.classList.remove('hnt-drawer-open');
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return fetchCart();
    }).then(function (cart) {
      renderCart(cart);
      openDrawer('added');
    }).catch(function (e) {
      alert((e && e.description) || T('cart_add_error', 'Kunde inte lägga i varukorgen.'));
    });
  }

  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  /* ---------- Händelser ---------- */
  document.addEventListener('click', function (ev) {
    var t = ev.target;

    var toggle = t.closest('[data-hnt-cart-toggle]');
    if (toggle) { ev.preventDefault(); fetchCart().then(function (c) { renderCart(c); openDrawer('view'); }); return; }

    if (t.closest('[data-hnt-drawer-close]')) { ev.preventDefault(); closeDrawer(); return; }

    var rm = t.closest('[data-hnt-remove]');
    if (rm) { ev.preventDefault(); removeLine(rm.getAttribute('data-hnt-remove')); return; }

    var upsellAdd = t.closest('[data-hnt-upsell-add]');
    if (upsellAdd) { ev.preventDefault(); addToCart(upsellAdd.getAttribute('data-hnt-upsell-add'), 1); return; }

    var atc = t.closest('[data-hnt-atc]');
    if (atc) { ev.preventDefault(); addToCart(atc.getAttribute('data-hnt-atc'), 1); return; }

    /* FAQ: en öppen åt gången */
    var faqQ = t.closest('.hnt-faq__q');
    if (faqQ) {
      var item = faqQ.closest('.hnt-faq__item');
      var list = item.parentElement;
      var wasOpen = item.classList.contains('is-open');
      qsa('.hnt-faq__item', list).forEach(function (it) {
        it.classList.remove('is-open');
        var sign = qs('.hnt-faq__sign', it);
        if (sign) sign.textContent = '+';
        var btn = qs('.hnt-faq__q', it);
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        var s = qs('.hnt-faq__sign', item);
        if (s) s.textContent = '−';
        faqQ.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    /* Landsfilter i återförsäljarvyn */
    var filter = t.closest('.hnt-locator__filter');
    if (filter) {
      qsa('.hnt-locator__filter', filter.parentElement).forEach(function (b) { b.classList.remove('is-active'); });
      filter.classList.add('is-active');
      applyLocatorFilter();
      return;
    }

    /* Märkesväljare (bitshållare) */
    var brand = t.closest('[data-hnt-brand]');
    if (brand && !brand.classList.contains('is-disabled')) {
      var wrap = brand.closest('[data-hnt-accessory]');
      qsa('[data-hnt-brand]', wrap).forEach(function (b) { b.classList.remove('is-active'); });
      brand.classList.add('is-active');
      var name = brand.getAttribute('data-hnt-brand');
      var vid = brand.getAttribute('data-variant-id');
      var nameEls = qsa('[data-hnt-brand-name]', wrap);
      nameEls.forEach(function (el) { el.textContent = name; });
      var buy = qs('[data-hnt-accessory-buy]', wrap);
      var bevaka = qs('[data-hnt-accessory-bevaka]', wrap);
      var avail = brand.getAttribute('data-hnt-available') === 'ja';
      var url = brand.getAttribute('data-hnt-url');
      /* Saldo: kop direkt. Inget saldo: lank till produktsidan och bevakningen. */
      if (buy) {
        if (vid && avail) { buy.removeAttribute('disabled'); buy.setAttribute('data-hnt-atc', vid); buy.style.display = ''; }
        else { buy.setAttribute('disabled', 'disabled'); buy.removeAttribute('data-hnt-atc'); buy.style.display = bevaka ? 'none' : ''; }
      }
      if (bevaka) {
        if (!avail && url) { bevaka.setAttribute('href', url); bevaka.style.display = ''; }
        else { bevaka.style.display = 'none'; }
      }
      return;
    }
  });

  /* Produktformulär: AJAX i stället för sidladdning */
  document.addEventListener('submit', function (ev) {
    var form = ev.target.closest('[data-hnt-atc-form]');
    if (!form) return;
    ev.preventDefault();
    var idInput = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"], select[name="id"]');
    if (!idInput || !idInput.value) return;
    addToCart(idInput.value, 1);
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') closeDrawer();
  });

  /* ---------- Återförsäljarsök ---------- */
  function applyLocatorFilter() {
    var locator = qs('[data-hnt-locator]');
    if (!locator) return;
    var q = (qs('.hnt-locator__search', locator) || { value: '' }).value.trim().toLowerCase();
    var activeBtn = qs('.hnt-locator__filter.is-active', locator);
    var land = activeBtn ? activeBtn.getAttribute('data-land') : 'ALLA';
    var visible = 0;
    var stores = qsa('.hnt-store', locator);
    stores.forEach(function (row) {
      var okLand = land === 'ALLA' || row.getAttribute('data-land') === land;
      var hay = (row.getAttribute('data-search') || '').toLowerCase();
      var okQ = !q || hay.indexOf(q) !== -1;
      var show = okLand && okQ;
      row.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    var empty = qs('.hnt-locator__empty', locator);
    if (empty) {
      empty.style.display = visible === 0 ? 'block' : 'none';
      var qEl = qs('[data-hnt-empty-q]', empty);
      if (qEl) qEl.textContent = q;
    }
    var count = qs('[data-hnt-locator-count]', locator);
    if (count) count.textContent = visible + T('count_of', ' av ') + stores.length + T('dealers_word', ' återförsäljare');
    /* Kartan: tona ner länder och markörer utanför filtret */
    qsa('.hnt-map-country', locator).forEach(function (p) {
      p.classList.toggle('is-dim', land !== 'ALLA' && p.getAttribute('data-cc') !== land);
    });
    qsa('.hnt-map-marker', locator).forEach(function (m) {
      m.classList.toggle('is-dim', land !== 'ALLA' && m.getAttribute('data-land') !== land);
    });
  }
  document.addEventListener('input', function (ev) {
    if (ev.target.classList && ev.target.classList.contains('hnt-locator__search')) applyLocatorFilter();
  });

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    fetchCart().then(renderCart).catch(function () {});
    applyLocatorFilter();
  });
})();
